import { RsValue } from '../models/base/BaseModel';
import { RegisterRequest, RegisterResponse } from '../models/user/UserModels';
import { IUserManagementResult } from '../models/user-management/UserManagementModel';
import api from './axios';

export const userService = {
  register: (data: RegisterRequest): Promise<RsValue<RegisterResponse>> =>
    api.post('/User/register', data),

  getUsers: (params: any): Promise<RsValue<IUserManagementResult[]>> =>
    api.get('/User/odata/users', { params }),

  getUser: (id: string): Promise<RsValue<IUserManagementResult>> =>
    api.get(`/User/${id}`),

  updateUser: (data: any): Promise<RsValue<string>> =>
    api.put('/User', data),

  deleteUser: (id: string): Promise<RsValue<string>> =>
    api.delete(`/User/${id}`)
};